import { createSlice } from "@reduxjs/toolkit";
import {
  AddCmsAction,
  AddLatestTermsAndConditionAction,
  DeleteCmsAction,
  GetAllCmsAction,
  GetLatestCmsAction,
  UpdateCmsAction,
} from "store/middlewares/cms";

export const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    cmsLoading: true,
    cms: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetAllCmsAction.pending, (state) => {
        // state.cmsLoading = true;
        // state.cms = [];
        state.cms = state.cms?.length > 0 ? state.cms : null;
      })
      .addCase(GetAllCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = action.payload.response;
      })
      .addCase(GetAllCmsAction.rejected, (state) => {
        state.cmsLoading = false;
        state.cms = [];
      })

      //get latest cms
      .addCase(GetLatestCmsAction.pending, (state) => {
        // state.cmsLoading = true;
        // state.cms = [];
        state.cms = state.cms?.length > 0 ? state.cms : null;
      })

      .addCase(GetLatestCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = action.payload.response;
      })

      .addCase(GetLatestCmsAction.rejected, (state) => {
        state.cmsLoading = false;
        state.cms = [];
      })

      //Update
      .addCase(UpdateCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms =
          action.payload.response.type === "issue"
            ? state.cms?.map((item) =>
              item.id === action.payload.response.id
                ? action.payload.response
                : item,
            )
            : [action.payload.response];
      })

      // Delete Reject Reason
      .addCase(DeleteCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = state.cms?.filter((item) => item.id !== action.payload.id);
      })

      //Add Reject Reason
      .addCase(AddCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = [action.payload.response, ...state.cms];
      })

      //Add latest terms and condition
      .addCase(AddLatestTermsAndConditionAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = action.payload.response;
      });
  },
});

export default cmsSlice.reducer;
